<template>
  <div class="content">
    <el-row style="height:28px">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>系统配置</el-breadcrumb-item>
            <el-breadcrumb-item>轮播配置</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container style="height:calc(100% - 30px);width:100%;position: relative;">
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="height:100% !important;" class="aside">
          <!--  -->
          <div class="build-table">
            <div
              style="display:flex;border-top:10px solid #f5f5f5;width:100%;height:80px;align-items:center;;padding:0px 10px">
              <span>类型:</span>
              <el-select v-model="search.carouselType" clearable placeholder="请选择">
                <el-option v-for="item in typeArry" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
              <span style="margin-left: 20px;">名称:</span>
              <el-input
                v-model="search.carouselName"
                placeholder="请输入名称"
                clearable
                style="width:220px;padding:10px;"
              >
                <!-- <el-button slot="append" icon="el-icon-search"></el-button> -->
              </el-input>
              <el-button type="primary"  @click="doFile">查询</el-button>

              <el-button type="primary" style="background:#275bcf;margin-left: 800px;" icon="el-icon-plus" @click="addFun">添加</el-button>
            </div>
            <!--  -->
            <div style="width:100%;height:calc(100% - 140px)">
              <el-table stripe :data="listData" height="100%" style="width: 100%;"
                :default-sort="{prop: 'createDate', order: 'descending'}"
                :header-cell-style="{background:'#F5F7F9',color:'#909399'}" :cell-style="rowClass">
                <template slot="empty">
                  <p>{{dataText}}</p>
                </template>
                <el-table-column label="序号" width="100">
                  <template slot-scope="scope">
                    <a>{{ scope.row.index}}</a>
                  </template>
                </el-table-column>
                <!-- <el-table-column label="图片">
                  <template slot-scope="scope">
                    <el-image style="width: 50px; height: 50px" :src="scope.row.carouselUrl_view"
                      :preview-src-list="scope.row.srcList">
                    </el-image>
                  </template>
                </el-table-column> -->
                <el-table-column label="名称">
                  <template slot-scope="scope">
                    <a>{{ scope.row.carouselName}}</a>
                  </template>
                </el-table-column>
                <el-table-column label="类型">
                  <template slot-scope="scope">
                    <a v-if="scope.row.carouselType==1">视频</a>
                    <a v-if="scope.row.carouselType==2">图片</a>
                  </template>
                </el-table-column>
                <el-table-column label="日期">
                  <template slot-scope="scope">
                    <span>{{ scope.row.createDate }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="排序">
                  <template slot-scope="scope">
                    <span>{{ scope.row.carouselSort }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="250">
                  <template slot-scope="scope">
                    <el-switch
                        v-model=" scope.row.showStatus"
                        active-color="#13ce66"
                        @change="changeSta(scope.$index, scope.row)"
                        >
                    </el-switch>
                    <el-button size="mini" style="margin-left: 10px;" type="primary" icon="el-icon-edit"
                      @click="handleEdit(scope.$index, scope.row)"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-delete"
                      @click="handleDel(scope.$index, scope.row)"></el-button>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 添加公告弹框 -->
              <!-- 新增窗口 -->
              <el-dialog :title="dialogTitle" :visible.sync="addFormVisible" center width="600px" :append-to-body="true"
                :lock-scroll="false" class="add-form">
                <el-form :model="addForm" label-width="200px" ref="addForm" label-position="right" :rules="rules">

                  <el-form-item label="类型：" prop="carouselType">
                    <el-select v-model="addForm.carouselType" clearable placeholder="请选择">
                      <el-option v-for="item in typeArry" :key="item.id" :label="item.name" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="图片" v-if="addForm.carouselType=='2'">
                    <el-upload class="avatar-uploader video-avatar" v-bind:action="uploadphotoUrl" :headers="uploadHead"
                      :data="uploadphotoData" :show-file-list="false" :on-success="handleIconSuccess">
                      <img v-if="photoUrl_view" :src="photoUrl_view" class="avatar video-avatar" />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                  </el-form-item>
                  <el-form-item label="视频：" v-if="addForm.carouselType=='1'">
                    <el-upload class="avatar-uploader" v-bind:action="uploadphotoUrl" v-bind:data="uploadphotoData"
                      v-bind:headers="uploadHead" v-bind:on-progress="uploadVideoProcess"
                      v-bind:on-success="handleVideoSuccess" v-bind:before-upload="beforeUploadVideo"
                      v-bind:show-file-list="false">
                      <video v-if="videoForm.showVideoPath !='' && !videoFlag" v-bind:src="videoForm.showVideoPath"
                        class="avatar video-avatar" controls="controls">您的浏览器不支持视频播放</video>
                      <i v-else-if="videoForm.showVideoPath =='' && !videoFlag"
                        class="el-icon-plus avatar-uploader-icon"></i>
                      <el-progress v-if="videoFlag == true" type="circle" v-bind:percentage="videoUploadPercent"
                        style="margin-top:7px;"></el-progress>
                    </el-upload>
                  </el-form-item>
                  <el-form-item label="名称：" prop="carouselName">
                    <el-input v-model="addForm.carouselName" autocomplete="off" style="width:217px;"></el-input>
                  </el-form-item>
                  <el-form-item label="排序：" prop="carouselSort">
                    <el-input v-model="addForm.carouselSort" autocomplete="off" style="width:217px;"></el-input>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="addFormVisible = false">取 消</el-button>
                  <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                </div>
              </el-dialog>
            </div>
            <!-- 分页展示 -->
            <!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="currentPage" :page-sizes="[3, 5, 10,20]" :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="totalItems"></el-pagination> -->
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
  import util from '../../../untils/util'
  import myHttp from '../../../untils/port'
  import base from '../../../untils/base'
  export default {
    data() {
      return {
        search: {
          //查询
          carouselName: '',
          carouselType: '',
        },
        listData: [], //表格数据
        addForm: {
          // groupType:'1',//组织类型，1项目，2施工企业，3建设企业
          carouselId: '',
          carouselName: '', //标题
          carouselType: '',//内容
          carouselSort: '',
          carouselUrl:''
        },
        dialogTitle: '',
        addFormVisible: false,
        groupId: '',
        currentPage: 1,
        pageSize: 10,
        totalItems: 0,
        storeOpt: [], //题库
        uploadphotoUrl: base.url + "/upload/uploadPhoto",
        uploadHead: {
          accessToken: util.session.get('token')
        },
        uploadphotoData: {
          type: '248'
        },
        dataText: '数据加载中...',
        rules: {
          title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
          content: [{ required: true, message: '请输入内容', trigger: 'blur' }],
          sort: [{ required: true, message: '请输入排序数字', trigger: 'blur' }],
        },
        groupType: '',
        groupId: '',
        createBy: util.session.get('user').id,
        photoUrl_view: '',
        typeArry: [{ name: '视频', id: '1' }, { name: '图片', id: '2' }],
        videoForm:{
          showVideoPath: '', //封面地址
        },
        videoFlag: false,
        videoUploadPercent: 0,
      //进度条的进度，
       isShowUploadVideo: false,
       roleId:'',
       //导入
      uploadUrl:myHttp.importSchoolStudentClassPersonExcel,
      uploadHead: {
          accessToken: util.session.get('token')
      },
      uploadData: {
          gradeId: '',
          classId: '',
          schoolId:''
      },
      }
    },

    mounted() {
      this.groupId = util.session.get('groupId')
      this.roleId = util.session.get('roleId')
      // console.log(this.addForm.scope)
      if ('' == this.groupId || ''==this.groupType =='') {
        this.$store.commit('setGroupId')
        this.$store.commit('getRoleId')
        this.groupId = this.$store.state.groupId
        this.roleId = this.$store.state.roleId
     
      }
      this.search.groupId = this.groupId
      if (this.roleId== '3') {
        this.groupType = '3'
      } else if (this.roleId == '4') {
        this.groupType = '2'
      } else if (this.roleId == '5') {
        this.groupType = '1'
      }
      this.getData()

    },
    methods: {
      //查询
      doFilter() {
        this.getData()
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.handleCurrentChange()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.currentChangePage()
      },
      // 监控当前页码
      currentChangePage(list) {
        this.getData()
      },
      rowClass() {
        //表头居中显示
        return 'text-align:center'
      },
      // 获取数据
      getData() {
        var that = this
        this.search.linkId = this.groupId
        this.search.platformType = this.groupType
        // this.search.pageSize = this.pageSize
        // this.search.pageNum = this.currentPage
        myHttp.findSysCarouselList(this.search).then(
          function (resp) {
            if (resp.data.code == '200') {
              var list = resp.data.data || []
              for (var i = 0; i < list.length; i++) {
                list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
                list[i].carouselUrl_view = list[i].carouselUrl && list[i].carouselUrl != '' ? base.httpCtx + list[i].carouselUrl : ''
                list[i].srcList = list[i].carouselUrl && list[i].carouselUrl != '' ? [base.httpCtx + list[i].carouselUrl] : []
                list[i].showStatus = list[i].showStatus==1?true:false
              }
              that.totalItems = resp.data.data.total || 0
              that.listData = list
              if (that.listData.length == 0) {
                that.dataText = '暂无数据'
              }
            } else {
              that.$message.error(resp.data.msg)
              that.dataText = '服务器出错'
            }
          },
          function () { }
        )
      },
      //修改
      handleEdit(index, row) {
        this.dialogTitle = '修改资讯'
        var that = this
        this.addFormVisible = true;
        this.addForm.carouselId = row.carouselId;
        this.addForm.carouselUrl = row.carouselUrl;
        this.addForm.carouselSort = row.carouselSort;
        this.addForm.carouselType = row.carouselType;
        this.addForm.carouselName = row.carouselName;
        
        if(row.carouselType==1){
          this.videoForm.showVideoPath = base.httpCtx + row.carouselUrl

        }else{
          this.photoUrl_view = base.httpCtx + row.carouselUrl

        }
        // console.log(this.photoUrl_view)
      },
      //保存
      sumbitAddRow(formName) {
        var that = this
        this.addForm.linkId = this.groupId
        // this.addForm.groupType = this.groupType
        // this.addForm.createBy = this.createBy
        this.addForm.platformType = this.groupType
        // console.log(this.addForm)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (!that.addForm.carouselId) {
              myHttp.addSysCarousel(that.addForm).then(function (resp) {
                if (resp.data.code == '200') {
                  that.addFormVisible = false
                  that.$message.success('创建成功')
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              })
            } else {
              // this.addForm.updateBy = this.createBy
              myHttp.editSysCarousel(that.addForm).then(function (resp) {
                if (resp.data.code == '200') {
                  that.addFormVisible = false
                  that.$message.success('修改成功')
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              })
            }
          }
        })
      },
      // handleNodeClick(data) {
      //   console.log(data)
      // },
      //添加
      addFun() {
        this.dialogTitle = '添加'
        this.checkData = [];
        this.addForm = {
          carouselId: '',
          carouselName: '', //标题
          carouselType: '',//内容
          carouselSort: '',
          carouselUrl:''
        },
          this.addFormVisible = true
      },
      //删除
      handleDel(index, row) {
        var that = this
        this.$confirm('此操作将永久删除该资讯, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            myHttp.deleteSysCarousel({
              carouselId: row.carouselId,
              // updateBy: this.createBy
            }).then(function (resp) {
              if (resp.data.code == "200") {
                that.$message.success('删除成功');
                that.getData();
              } else {
                that.$message.error(resp.data.msg);
              }
            });
          })
          .catch((err) => { })
      },
      // 上传封面图片成功
      handleIconSuccess(res, file) {
        if (res.code == '200') {
          this.photoUrl_view = URL.createObjectURL(file.raw)
          this.addForm.carouselUrl = res.data.saveUrls
          // var time = new Date().getMilliseconds()
          // this.photoUrl_view = base.httpCtx + res.data.saveUrls 
          // console.log(this.photoUrl_view)
          // console.log(this.addForm.photoUrl)
        } else {
          this.$message.error(res.msg)
        }
      },
        //上传前回调
    beforeUploadVideo(file) {
      var fileSize = file.size / 1024 / 1024 < 150
      if (
        [
          'video/mp4',
          'video/ogg',
          'video/flv',
          'video/avi',
          'video/wmv',
          'video/rmvb',
          'video/mov',
        ].indexOf(file.type) == -1
      ) {
        this.$message.msg('请上传正确的视频格式')
        return false
      }
      if (!fileSize) {
        this.$message.error('视频大小不能超过50MB')
        return false
      }
      this.isShowUploadVideo = false
    },
      //进度条
      uploadVideoProcess(event, file, fileList) {
        this.videoFlag = true
        this.videoUploadPercent = file.percentage.toFixed(0) * 1
      },
      //上传成功回调
      handleVideoSuccess(res, file) {
        this.isShowUploadVideo = true
        this.videoFlag = false
        this.videoUploadPercent = 0

        //后台上传地址
        if (res.code == 200) {
          this.videoForm.showVideoPath = base.httpCtx + res.data.saveUrls
          console.log(this.videoForm.showVideoPath )
          // this.poster = res.data.saveUrls
          this.addForm.carouselUrl = res.data.saveUrls
          // this.posterView =
          //   base.httpCtx + res.data.saveImgUrls + '?' + 't=' + new Date().getTime()
          this.videoPath = res.data.saveUrls
          this.playTime = res.data.videoTime
        } else {
          this.$message.error(res.msg)
        }
      },
      doFile(){
        this.getData()
      },
      changeSta(index,row){
         var that = this;
         var showStatus ='';
         console.log(row.showStatus)
          showStatus = row.showStatus==false?2:1
          myHttp.switchShowStatus({
              carouselId: row.carouselId,
              showStatus: showStatus
            }).then(function (resp) {
              if (resp.data.code == "200") {
                that.$message.success(resp.data.msg);
                that.getData();
              } else {
                that.$message.error(resp.data.msg);
              }
            });


      }
      // //添加选题
      // addOpt() {
      //   var length = this.strOpt.length
      //   var index = parseInt(this.strOpt[length - 1].index) + 1
      //   var obj = {
      //     index: index,
      //     type: '',
      //     num: '',
      //     score: '',
      //   }
      //   this.strOpt.push(obj)
      // },
    },

  }
</script>
<style>
  @import '../../../assets/css/common.css';
  /* .el-table--border th, .el-table__fixed-right-patch{
        border-bottom: 1px solid #303133;
    }
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid #303133;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: 1px solid #303133;
    }
    .el-table--border, .el-table--group{
        border: 1px solid #303133;
    } */
</style>
<style scoped>
  .content>>>.el-card__body {
    padding: 0 !important;
    height: 100% !important;
  }

  .grid-content {
    height: 2.5vh;
    font-size: 1.6vh;
  }

  .aside {
    box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
    border-radius: 10px !important;
    border: 0px !important;
    background-color: #ecf0f5;
    display: flex;
    flex-direction: column;
  }

  .search-section {
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin: 20px 35px 20px -12px;
    height: 40px;
    justify-content: space-between;
  }

  .el-end {
    height: 47px;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    text-align: center;
  }

  .build-table {
    height: 100%;
    width: 100%;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    background: #fff;
  }

  .el-pagination {
    margin: auto;
  }

  .el-table--fit {
    border-bottom: 1px solid #f5f5f5;
  }

  .content>>>.el-table th>.cell {
    text-align: center !important;
  }

  .video-avatar {
    width: 200px;
    height: 200px;
  }
</style>